import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { getCurrencyIcon } from '../../../../../../shared/js/get-currency-icon';

const Table = ({ table, intl, showMoreRows, pagination, gotoPage, can }) => (
	<div className="table-container conversions-approve-table">
		<table className="simple-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>{table.headers.map((header, i) => <th key={i}>{intl(header.title)}</th>)}</tr>
			</thead>

			<tbody className="simple-table__body">
				{table.rows.map((row, i) => (
					<tr key={i}>
						<td className="id">
							<span>{row.id}</span>
						</td>
						<td className="date">
							<span>{row.date}</span>
						</td>
						<td className="affiliate">
							<span>{row.affiliate}</span>
						</td>
						<td className="offer">
							<span>{row.offer}</span>
						</td>
						<td className="geo-ip">
							<span>{row.country}{row.city ? `, ${row.city}` : ''} {row.ip}</span>
						</td>
						<td className="payout">
							<span>{row.payout} {getCurrencyIcon(row.currency)}</span>
						</td>
						<td className="campaign">
							<span>{row.campaign}</span>
						</td>
					</tr>
				))}
			</tbody>
		</table>

		<div className="table-container__pagination">
			<div className="table-container__pagination-items">
				{pagination.pages.map(pageIndex => {
					const page = ++pageIndex;
					return (
						<a
							key={page}
							href="#"
							className={cn({
								'table-container__pagination-item': true,
								active: page === pagination.currentPage
							})}
							onClick={e => {
								e.preventDefault();
								gotoPage(page);
							}}
						>
							{page}
						</a>
					);
				})}
			</div>
		</div>
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	pagination: PropTypes.object,
	gotoPage: PropTypes.func,
	intl: PropTypes.func,
	showMoreRows: PropTypes.func,
	can: PropTypes.func
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-approve/components/table/main.js